import React from 'react';
import Label from "semantic-ui-react/dist/es/elements/Label/Label.js";
export var getPageItemMarkup = function getPageItemMarkup(isShowingPageNumbers) {
  return isShowingPageNumbers ? undefined : React.createElement(Label, {
    circular: true,
    content: null,
    empty: true,
    size: "tiny"
  });
};